import type { SerializedCombinedMeter } from '@enmon/commons/lib/enmon';
import type { LocationBootstrapMeter } from '@/features/location-bootstrap/location-bootstrap-types';

type MeterPlacementFields = Pick<
  LocationBootstrapMeter,
  'buildingId' | 'buildingName' | 'floorName' | 'floorplanLat' | 'floorplanLng' | 'gpsLat' | 'gpsLng'
>;

export function readBootstrapMeterPlacementFields(meter: SerializedCombinedMeter): MeterPlacementFields {
  return {
    buildingId: meter.inventory_location_building?.id,
    buildingName: meter.inventory_location_building?.name,
    floorName: meter.buildingFloor == null ? undefined : String(meter.buildingFloor),
    floorplanLat: meter.floorplan_lat,
    floorplanLng: meter.floorplan_lng,
    gpsLat: meter.location?.coordinates?.[1],
    gpsLng: meter.location?.coordinates?.[0],
  };
}
